export const getHostName = () => process.env.REACT_APP_HOST_NAME ?? window.location.hostname;
